// Temporary UI rollout only. Keep shared by menu and route until explicitly released.
const WORK_BOARD_INTERNAL_EMAILS: readonly string[] = [
  'washday@washday.mx',
  'validator@washday.mx'
];

export const canAccessWorkBoard = (user?: { email?: unknown } | null): boolean =>
  typeof user?.email === 'string' && WORK_BOARD_INTERNAL_EMAILS.includes(user.email.trim().toLowerCase());
